import React, { useRef, useState } from "react";
import { TextAnnotateBlend } from "./text-annotate-blend";
import { Annotation, AnnotationApi } from "./annotation-api";

import { Button, Grid, Popover, Typography } from "@material-ui/core";
import { Auto, Text } from "../controls";

type AnnotationProps = {
  api: AnnotationApi;
  tag?: string;
  style?: React.CSSProperties;
  color?: (tag?: string) => string;
  highlightColor?: string;
};

const defaultStyle = {
  fontFamily: "Helvetica",
  whiteSpace: "pre-wrap",
};

const defaultColor = () => "#ffee00";

export function AnnotationText({
  api,
  color,
  style,
  highlightColor,
  ...props
}: AnnotationProps) {
  const { onSelectionChange, onCancelSelection, save, data, sectionForm } = api;

  const ref = useRef<HTMLDivElement>();
  const [anchorEl, setAnchorEl] = useState(null);

  const onOpen = () => {
    setAnchorEl(ref.current);
  };

  const onClose = () => {
    if (anchorEl) {
      onCancelSelection();
    }
    setAnchorEl(null);
  };

  const value = data((s) => s.annotations);
  const onTextSelectionChange = (change: Annotation[]) => {
    const isAdded = change.length > value.length;
    if (isAdded) {
      onOpen();
      onSelectionChange(change);
    }
  };
  const colorFn = color || defaultColor;
  const getSpan = (a: Annotation) => ({
    ...a,
    tag: a.tag || props.tag,
    color: colorFn(a.tag),
    start: a.start,
    end: a.end,
  });

  const onSave = () => {
    save();
    setAnchorEl(null);
  };

  const text = data((s) => s.text);

  const { correctSectionName, coderNote } = sectionForm.controls;
  return (
    <div ref={ref}>
      <TextAnnotateBlend
        style={
          (style || { ...defaultStyle, ...{ color: highlightColor } }) as any
        }
        content={text}
        value={value}
        getSpan={getSpan}
        onChange={onTextSelectionChange}
      />

      <Popover
        open={anchorEl}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <div style={{ padding: 12 }}>
          <Grid container direction="column" spacing={0} style={{ width: 340 }}>
            <Grid item>
              <Typography variant="h6">Add Feed Back</Typography>
            </Grid>

            <Grid container item direction="row" style={{ width: "100%" }}>
              <Grid item>
                <Typography
                  style={{ whiteSpace: "nowrap" }}
                  variant="body2"
                  color="textSecondary"
                >
                  Current Section Name:
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body2" color="textPrimary">
                  &nbsp; &nbsp;{props?.tag}
                </Typography>
              </Grid>
            </Grid>

            <Grid item style={{ width: "100%" }}>
              <Auto {...correctSectionName} />
            </Grid>

            <Grid item style={{ width: "100%" }}>
              <Text {...coderNote} />
              <br />
              <br />
            </Grid>

            <Grid
              item
              container
              direction="row"
              style={{ paddingRight: 18, flexWrap: "nowrap", width: "100%" }}
            >
              <Grid item>
                <Button size="small" variant="outlined" onClick={onClose}>
                  Cancel
                </Button>
              </Grid>
              <Grid item style={{ flexGrow: 1 }} />
              <Grid item>
                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  onClick={onSave}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Popover>
    </div>
  );
}
